import Vue from "vue";
import store from '@store'

Vue.prototype.$startLoading = (loaderMessage) => {
  store.dispatch('loading/setLoadingStart', loaderMessage, {
    root: true
  })
};
Vue.prototype.$endLoading = function(loaderMessage) {
  store.dispatch('loading/setLoadingEnd', loaderMessage, {
    root: true
  })
};
Vue.prototype.$isLoading = function(loaderMessage) {
  return store.getters['loading/isLoading'](
    loaderMessage
  )
};
Vue.prototype.$anyLoading = function() {
  return store.getters['loading/anyLoading']
};
